import type { PromptConfig } from '@/types/edit/PromptConfig.ts';
import { DEFAULT_AI_MODEL } from '@/constants/DefaultAiModel.ts';

export const DefaultPromptConfigs: Record<PromptConfig['id'], PromptConfig> = {
    ['b57306a6-3e7a-4f74-97f6-1f06f3142b9a']: {
        id: 'b57306a6-3e7a-4f74-97f6-1f06f3142b9a',
        profileId: '6f18d96e-8bd5-46c7-928f-923b1f32ca35',
        stepId: '30ce2bbf-dedf-4b3e-a4c0-b85602ce825f',
        name: 'Algorithm selection',
        rawText: `Return the three most common algorithms to solve the following coding problem with their Big O time and space complexity and a one sentence short explanation, sorted from worst to best time complexity. Return as much algorithms as possible.`,
        outputFormatInstruction: `Return a JSON array as the result. The JSON must have these fields:
   "title": the algorithm name.
   "smallTitle": the time complexity and space complexity formatted as follows: "Time complexity: TIME_COMPLEXITY_HERE | Space complexity: SPACE_COMPLEXITY_HERE".
   "description": a one sentence short explanation.

Do not return anything else other than the JSON array.
Do not format the output, only return the JSON array as is.`,
        order: 0,
        formatAs: 'choice',
        includeScreenCapture: true,
        modelId: DEFAULT_AI_MODEL,
        reasoningEffort: 'low',
        editable: false,
    },
    ['6e7a389a-696e-4ad3-9f38-2a49e61bc43d']: {
        id: '6e7a389a-696e-4ad3-9f38-2a49e61bc43d',
        profileId: '6f18d96e-8bd5-46c7-928f-923b1f32ca35',
        stepId: '807e8d2d-e065-4815-9547-ee455e5194f7',
        name: 'Code',
        rawText: `Return the commented code solution for the supplied coding problem in the programming language $PROGRAMMING_LANGUAGE use the $CHOICE_ALGORITHM_SELECTION algorithm. Include a multi comment on top followed by a line break shortly explaining how the $CHOICE_ALGORITHM_SELECTION algorithm works in combination with the solution.`,
        outputFormatInstruction: `Code formatting:
   Make all variables be in camel case.
   Include a line break before every comment.
   Use modern coding standards.

Output formatting:
   Output only plain text. Do not output markdown.
   Do not include example usages in the output.
   Use the following editor config to format the code: $FORMATTING_CONFIG.`,
        order: 0,
        formatAs: 'code',
        includeScreenCapture: true,
        modelId: DEFAULT_AI_MODEL,
        reasoningEffort: 'low',
        editable: false,
    },
    ['bcdd0a89-db5a-4ef2-8e2b-2dff88b9272f']: {
        id: 'bcdd0a89-db5a-4ef2-8e2b-2dff88b9272f',
        profileId: '6f18d96e-8bd5-46c7-928f-923b1f32ca35',
        stepId: '807e8d2d-e065-4815-9547-ee455e5194f7',
        name: 'Tests',
        rawText: `Return code with 8 tests for the following code: "$OUTPUT_CODE"`,
        outputFormatInstruction: `Code formatting:
   Only return the method calls. No asserts.
   Add a short comment above every test describing what it's doing
   Include a line break before every comment.
   Use modern coding standards.

Output formatting:
   Output only plain text. Do not output markdown.
   Do not include example usages in the output.
   Use the following editor config to format the code: $FORMATTING_CONFIG.`,
        order: 1,
        formatAs: 'code',
        includeScreenCapture: false,
        modelId: DEFAULT_AI_MODEL,
        reasoningEffort: 'none',
        editable: false,
    },
    ['89974ad1-22aa-417d-a18c-cb120b6931a2']: {
        id: '89974ad1-22aa-417d-a18c-cb120b6931a2',
        profileId: '6f18d96e-8bd5-46c7-928f-923b1f32ca35',
        stepId: '807e8d2d-e065-4815-9547-ee455e5194f7',
        name: 'Complexity',
        rawText:
            'Return the time and space complexity and explain them for the following code using the $CHOICE_ALGORITHM_SELECTION algorithm: "$OUTPUT_CODE"',
        outputFormatInstruction: `Format the output as markdown. Only use heading level 3 or smaller in the markdown output.`,
        order: 2,
        formatAs: 'markdown',
        includeScreenCapture: false,
        modelId: DEFAULT_AI_MODEL,
        reasoningEffort: 'none',
        editable: false,
    },
};
